/**
 * R5HelpCard
 * -----------------------------------------------------------
 * Training / Consulting card with title, tag pills, description.
 * Used in the Help & Support page Training/Consulting tabs.
 *
 * Props:
 *   title:       string
 *   tags:        string[]  (rendered as pills)
 *   description: string or node
 *   href:        renders the whole card as an <a>
 *   onClick:     renders the whole card as a <button>
 *   action:      optional CTA node appended below description
 */
import React from 'react';

export function R5HelpCard({
  title,
  tags = [],
  description,
  href,
  onClick,
  action,
  className = '',
  ...rest
}) {
  const cls = ['r5-help-card', className].filter(Boolean).join(' ');
  const inner = (
    <>
      {title && <h4>{title}</h4>}
      {tags.length > 0 && (
        <div className="r5-help-card__tags">
          {tags.map((t, i) => (
            <span key={i} className="r5-help-card__tag">{t}</span>
          ))}
        </div>
      )}
      {description && <p>{description}</p>}
      {action}
    </>
  );

  if (href) {
    return (
      <a className={cls} href={href} {...rest} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
        {inner}
      </a>
    );
  }
  if (onClick) {
    return (
      <button type="button" className={cls} onClick={onClick} {...rest} style={{ textAlign: 'left', font: 'inherit', cursor: 'pointer' }}>
        {inner}
      </button>
    );
  }
  return (
    <article className={cls} {...rest}>
      {inner}
    </article>
  );
}

export default R5HelpCard;
